/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  FullGlobalDns,
  FullSubnet,
  FullTag,
  GetAllAccessRuleOptionsResponse,
  GetAllAccessRulesForResponse,
  GetAllDevicesRequest,
  GetAllDevicesResponse,
  GetAllExitNodesRequest,
  GetAllGroupsRequest,
  GetAllPreAuthKeysRequest,
  GetAllSubnetsRequest,
  GetAllTagsRequest,
  GetAllUsersRequest,
  GetChangelogRequest,
  GetGeneralSettingsResponse,
  GetPendingExitNodesRequest,
  GetPendingRoutesRequest,
  GetSingleDeviceResponse,
  GetSingleGroupMembersRequest,
  GetSingleGroupResponse,
  GetSingleUserResponse,
  ListForFullAccessRule,
  ListForFullSplitDnsDomain,
  ListForSimpleAccount,
  ListForSimpleChangelogEntry,
  ListForSimpleExtraDnsDomain,
  PageForFullHeadscalePreAuthKey,
  PageForGetAllGroupsResponseItem,
  PageForGetAllSubnetsResponseItem,
  PageForGetExitNodesResponseItem,
  PageForGetPendingRoutesResponseItem,
  PageForSimpleChangelogEntry,
  PageForSimpleTag,
  PageForSimpleUser,
} from '../models/index';

export interface DumpDeviceStateRequest {
    uuid: string;
}

export interface GetAllAccessRulesForDeviceRequest {
    uuid: string;
}

export interface GetAllAccessRulesForGroupRequest {
    uuid: string;
}

export interface GetAllAccessRulesForUserRequest {
    uuid: string;
}

export interface GetAllApprovedExitNodesRequest {
    GetAllExitNodesRequest?: GetAllExitNodesRequest;
}

export interface GetAllDevicesOperationRequest {
    GetAllDevicesRequest?: GetAllDevicesRequest;
}

export interface GetAllGroupsOperationRequest {
    GetAllGroupsRequest?: GetAllGroupsRequest;
}

export interface GetAllPreAuthKeysOperationRequest {
    GetAllPreAuthKeysRequest?: GetAllPreAuthKeysRequest;
}

export interface GetAllSubnetsOperationRequest {
    GetAllSubnetsRequest?: GetAllSubnetsRequest;
}

export interface GetAllTagsOperationRequest {
    GetAllTagsRequest?: GetAllTagsRequest;
}

export interface GetAllUsersOperationRequest {
    GetAllUsersRequest?: GetAllUsersRequest;
}

export interface GetChangelogOperationRequest {
    GetChangelogRequest?: GetChangelogRequest;
}

export interface GetDeviceExtraDnsRequest {
    uuid: string;
}

export interface GetPendingExitNodesOperationRequest {
    GetPendingExitNodesRequest?: GetPendingExitNodesRequest;
}

export interface GetPendingSubnetRoutesRequest {
    GetPendingRoutesRequest?: GetPendingRoutesRequest;
}

export interface GetSingleDeviceRequest {
    uuid: string;
}

export interface GetSingleGroupRequest {
    uuid: string;
}

export interface GetSingleGroupMembersOperationRequest {
    uuid: string;
    GetSingleGroupMembersRequest?: GetSingleGroupMembersRequest;
}

export interface GetSingleSubnetRequest {
    uuid: string;
}

export interface GetSingleUserRequest {
    uuid: string;
}

export interface GetTagRequest {
    uuid: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async dumpDeviceStateRaw(requestParameters: DumpDeviceStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling dumpDeviceState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/devices/{uuid}/dump-state`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async dumpDeviceState(requestParameters: DumpDeviceStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.dumpDeviceStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportChangelogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleChangelogEntry>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/changelog/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async exportChangelog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleChangelogEntry> {
        const response = await this.exportChangelogRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRuleOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRuleOptionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/access-rules/all-for-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRuleOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRuleOptionsResponse> {
        const response = await this.getAllAccessRuleOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullAccessRule>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/access-rules/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullAccessRule> {
        const response = await this.getAllAccessRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesForDeviceRaw(requestParameters: GetAllAccessRulesForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRulesForResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAllAccessRulesForDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/access-rules/all-for-device/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRulesForDevice(requestParameters: GetAllAccessRulesForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRulesForResponse> {
        const response = await this.getAllAccessRulesForDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesForGroupRaw(requestParameters: GetAllAccessRulesForGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRulesForResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAllAccessRulesForGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/access-rules/all-for-group/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRulesForGroup(requestParameters: GetAllAccessRulesForGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRulesForResponse> {
        const response = await this.getAllAccessRulesForGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesForUserRaw(requestParameters: GetAllAccessRulesForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRulesForResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAllAccessRulesForUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/access-rules/all-for-user/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRulesForUser(requestParameters: GetAllAccessRulesForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRulesForResponse> {
        const response = await this.getAllAccessRulesForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleAccount>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/accounts/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleAccount> {
        const response = await this.getAllAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllApprovedExitNodesRaw(requestParameters: GetAllApprovedExitNodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetExitNodesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/exit-nodes/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllExitNodesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllApprovedExitNodes(requestParameters: GetAllApprovedExitNodesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetExitNodesResponseItem> {
        const response = await this.getAllApprovedExitNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllDevicesRaw(requestParameters: GetAllDevicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllDevicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/devices/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllDevicesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllDevices(requestParameters: GetAllDevicesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllDevicesResponse> {
        const response = await this.getAllDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllGroupsRaw(requestParameters: GetAllGroupsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetAllGroupsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/groups/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllGroupsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllGroups(requestParameters: GetAllGroupsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetAllGroupsResponseItem> {
        const response = await this.getAllGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllPreAuthKeysRaw(requestParameters: GetAllPreAuthKeysOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForFullHeadscalePreAuthKey>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/pre-auth-keys/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllPreAuthKeysRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllPreAuthKeys(requestParameters: GetAllPreAuthKeysOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForFullHeadscalePreAuthKey> {
        const response = await this.getAllPreAuthKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllSubnetsRaw(requestParameters: GetAllSubnetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetAllSubnetsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/subnets/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllSubnetsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllSubnets(requestParameters: GetAllSubnetsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetAllSubnetsResponseItem> {
        const response = await this.getAllSubnetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllTagsRaw(requestParameters: GetAllTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleTag>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/tags/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllTagsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllTags(requestParameters: GetAllTagsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleTag> {
        const response = await this.getAllTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllUsersRaw(requestParameters: GetAllUsersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/users/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllUsersRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllUsers(requestParameters: GetAllUsersOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleUser> {
        const response = await this.getAllUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getChangelogRaw(requestParameters: GetChangelogOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleChangelogEntry>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/changelog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetChangelogRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getChangelog(requestParameters: GetChangelogOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleChangelogEntry> {
        const response = await this.getChangelogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeviceExtraDnsRaw(requestParameters: GetDeviceExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleExtraDnsDomain>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getDeviceExtraDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/dns/{uuid}/get-device-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeviceExtraDns(requestParameters: GetDeviceExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleExtraDnsDomain> {
        const response = await this.getDeviceExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGeneralSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGeneralSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/settings/general`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGeneralSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGeneralSettingsResponse> {
        const response = await this.getGeneralSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGlobalDnsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullGlobalDns>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/dns/get-global`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGlobalDns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullGlobalDns> {
        const response = await this.getGlobalDnsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingExitNodesRaw(requestParameters: GetPendingExitNodesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetExitNodesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/exit-nodes/get-pending-exit-nodes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetPendingExitNodesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPendingExitNodes(requestParameters: GetPendingExitNodesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetExitNodesResponseItem> {
        const response = await this.getPendingExitNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingSubnetRoutesRaw(requestParameters: GetPendingSubnetRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetPendingRoutesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/subnets/get-pending-routes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetPendingRoutesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPendingSubnetRoutes(requestParameters: GetPendingSubnetRoutesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetPendingRoutesResponseItem> {
        const response = await this.getPendingSubnetRoutesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleDeviceRaw(requestParameters: GetSingleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleDeviceResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/devices/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleDevice(requestParameters: GetSingleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleDeviceResponse> {
        const response = await this.getSingleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleGroupRaw(requestParameters: GetSingleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleGroupResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/groups/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleGroup(requestParameters: GetSingleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleGroupResponse> {
        const response = await this.getSingleGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleGroupMembersRaw(requestParameters: GetSingleGroupMembersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleUser>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleGroupMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/customer/groups/{uuid}/members`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetSingleGroupMembersRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleGroupMembers(requestParameters: GetSingleGroupMembersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleUser> {
        const response = await this.getSingleGroupMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleSubnetRaw(requestParameters: GetSingleSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullSubnet>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/subnets/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleSubnet(requestParameters: GetSingleSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullSubnet> {
        const response = await this.getSingleSubnetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleUserRaw(requestParameters: GetSingleUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleUserResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/users/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleUser(requestParameters: GetSingleUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleUserResponse> {
        const response = await this.getSingleUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSplitDnsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullSplitDnsDomain>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/dns/get-split-dns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSplitDns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullSplitDnsDomain> {
        const response = await this.getSplitDnsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTagRaw(requestParameters: GetTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullTag>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/tags/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTag(requestParameters: GetTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullTag> {
        const response = await this.getTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async openWebsocketRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/customer/websocket`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async openWebsocket(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openWebsocketRaw(initOverrides);
    }

}
